import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilsService } from 'ng2-date-picker/lib/common/services/utils/utils.service';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Bank } from 'src/app/shared/models/bank.model';
import { Operator } from 'src/app/shared/models/operator.model';
import { BankService } from 'src/app/shared/services/core/bank.component.service';

@Component({
  selector: 'app-cadastro-bancos',
  imports: [TegelModule, CommonModule],
  templateUrl: './cadastro-bancos.component.html',
  styleUrl: './cadastro-bancos.component.scss'
})
export class CadastroBancosComponent implements OnInit {
  banks: Bank[];
  operators: Operator[];
  row: Bank;
  pageBank = 1;
  pageOperator = 1;
  searchText = '';
  order = "user";

  constructor(private bankService: BankService,
              private dialogService: DialogService,
              private toastr: ToastrService,
              private utilService: UtilService
  ) {
    this.banks = [];
    this.operators = [];
    this.row = new Bank();
  }

  ngOnInit(): void {
    this.getAllBanks();
  }

  deleteBank(cod: any, desc: any) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o banco ' + desc + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed){
        this.bankService.delete(cod).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do {
              index = this.banks.findIndex(c => c.id === cod);
              if (index > -1){
                this.banks.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  getAllBanks() {
    this.bankService.get().subscribe((result) => {
      if (result) {
        this.banks = result;
      }
    });
  }

  openSaveBank(bank = new Bank, update?: boolean){
    if (update) {
      this.getBankById(bank.id);
    } else {
      //this.openModal(bank);
    }
  }

  // openModal(bank: Bank, update?: boolean){
  //   this.dialogService.addDialog(SaveBankComponent, {
  //     bank: bank, update: update,
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getAllBanks();
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });

  // }

  getBankById(id: number){
    this.bankService.getByKey(id).subscribe((result) => {
      if (result) {
       // this.openModal(result, true);
      }
    })
  }
}
